 class AddToCartElement extends HTMLElement {
  constructor() {
  super();
    this.form = this.parentNode;
    this.formBtn = this.form.querySelector('button[type="submit"]');
    this.updateCartBtn = this.form.querySelector('#ProductPopup-giftcard');

    this.header = document.querySelector('sticky-header');

    this.onBodyClick = this.handleBodyClick.bind(this);

    this.clearCart = this.form.querySelector('.Button__clear-cart');
    this.keepCart = this.form.querySelector('.Button__keep-cart');

    this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');

    this.init();

  }

  init() {
    var productSku = this.form.querySelector('input[name="sku"]').getAttribute('value');
    var seletedProductType = 'Product';
    if(productSku.startsWith('GC')) {
      seletedProductType = 'Giftcard';
    }
    this.form.addEventListener('submit', this.disableFormSubmit.bind(this));
    this.getCartContents(seletedProductType);
  }

  disableFormSubmit() {
    return false
  }

  getCartContents(seletedProductType) {
    fetch('/cart.js', {
      method: 'GET'
    })
    .then(response => response.json())
    .then((response) => {
      var productsInCart = {'updates': []};
      response.items.forEach((item, number) => {
        if (seletedProductType == 'Giftcard') {
          if (!item.sku.startsWith('GC')) {
            productsInCart['updates'].push(0);
          }
        } else {
          if (item.sku.startsWith('GC')) {
            productsInCart['updates'].push(0);
          }
        }
        this.clearCart.addEventListener('click', this.triggerAlert.bind(this, productsInCart));
      });
    })
    .catch(console.error)
  }

  triggerAlert(productsInCart) {
    this.removeItems(productsInCart);
  }

  removeItems(productsInCart) {
    fetch('/cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(productsInCart),
    })
    .then(response => response.json())
    .then((response) => {
      this.addCurrentProduct()
    })
    .catch(console.error)
  }

  addCurrentProduct() {
    var productId = this.form.querySelector('input[name="id"]').getAttribute('value');
    this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

    var addData = {
      'id': productId,
      'quantity':1
    };

    const config = fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    config.body = JSON.stringify({
      ...addData,
      sections: this.cart.getSectionsToRender().map((section) => section.id),
      sections_url: window.location.pathname
    });

    fetch(`${routes.cart_add_url}`, config)
    .then((response) => response.json())
    .then((response) => {
      if (response.status) {
        this.handleErrorMessage(response.description);
        return;
      }
      this.cart.renderContents(response);
    })
    .catch((e) => {
      console.error(e);
    })
    .finally(() => {
      this.querySelector('.loading-overlay__spinner').classList.add('hidden');
      this.querySelector('#ProductPopup-giftcard').classList.add('hidden');
      this.formBtn.parentNode.classList.remove('hidden');
    });
  }

  renderContents(parsedState) {
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section => {
      document.getElementById(section.id).innerHTML =
        this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    }));
    if (this.header) this.header.reveal();
    this.open();
  }

  getSectionsToRender() {
    if(document.querySelector('cart-notification')){
      return [
        {
          id: 'cart-notification-product',
          selector: `#cart-notification-product-${this.productId}`,
        },
        {
          id: 'cart-notification-button'
        },
        {
          id: 'cart-icon-bubble'
        }
      ];
    } else if (document.querySelector('cart-drawer')) {
      return [
        {
          id: 'sc-cart-drawer',
          selector: '#CartDrawer'
        },
        {
          id: 'cart-icon-bubble'
        }
      ];
    } else { return [] }
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  setActiveElement(element) {
    this.activeElement = element;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.cart && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  open() {
    this.cart.classList.add('animate', 'active');
    this.cart.addEventListener('transitionend', () => {
      this.cart.focus();
      trapFocus(this.cart);
    }, { once: true });
    document.body.addEventListener('click', this.onBodyClick);
  }

}
customElements.define('add-to-cart', AddToCartElement);
